import {createUseStyles} from 'react-jss';
import MediaQueries from '../../style-helper/MediaQueries';
import Spacing from '../../style-helper/Spacing';

export default createUseStyles({
  textContainer: {
    marginBottom: Spacing.quad,
    
    ul: {
      marginLeft: 0,
    },
    
    li: {
      paddingTop: 20,
      listStyleType: 'none',
      minHeight: 90,
      
      '&:first-child': {
        paddingTop: 0,
        
        [MediaQueries.phone]: {
          marginTop: 30,
          borderBottom: 'solid 1px #ccc',
        },
      },
      
    },
  },
  cardDetails: {
    fontSize: 14,
    lineHeight: '1.43',
  },
  cardImage: {
    float: 'left',
    width: 112,
    height: 72, // IE compatibility
    marginRight: 10,
    marginBottom: 35,
  },
});
